import {
	SET_SELECTED_TREND_SIGNAL_SETTINGS,
	GET_TREND_SIGNAL_SETTINGS,
	ON_TOGGLE_SIGNAL,
	ON_CUSTOM_DOMAIN_COMPARISON,
	TOGGLE_COMMON_GROUP_EXPANDED,
	TOGGLE_DISTINCT_GROUP_EXPANDED,
	ON_TOGGLE_DISTINCT_ASSET_GROUP,
	SET_DISTINCT_ASSET_GROUP,
	SHOW_GLOBAL_SIGNAL_NAME_DIALOG,
	CLOSE_GLOBAL_SIGNAL_NAME_DIALOG,
	LOAD_TREND_SIGNALS,
	SHOW_TOAST_MESSAGE,
	SET_MENU_OPENED,
	SET_FILTER_TEXT,
	DESELECT_ALL_SIGNALS,
	CLEAR_SELECTED_TREND_SIGNALS,
	GET_TREND_SIGNAL_SETTING_BY_ROUTE_ID
} from "./TrendSignalSettingsActionsType";
import { ADVANCED_SETTINGS_DRAWER_PATH, TREND_PATH } from "../../ModulePath";

import { RESET_STATE, SET } from "@/stores/CommumActionTypes";
import TrendSignalsService from "@/services/common/TrendSignalsService";
import i18n from "@/i18n";
import ToastMessageType from "@/constants/enums/ToastMessageType";

const actions = {
	[SET]: ({ commit }, trendSignals) =>
	{
		commit(SET, trendSignals);
	},

	[SET_SELECTED_TREND_SIGNAL_SETTINGS]({ state, commit })
	{
		if (!Array.isArray(state.SelectedTrendSignals) || state.SelectedTrendSignals.length === 0) return;

		const allDistinctSignals = state.availableDistinctSignalGroups
			.flatMap((group) => group.signals);

		const allAvailableSignals = [ ...state.availableCommonSignals, ...allDistinctSignals ];

		const filteredSelected = state.SelectedTrendSignals.filter((selected) => allAvailableSignals.some(
			(available) => available.name === selected.name &&
        (available.asset ? available.asset === selected.asset : true)
		));

		commit(SET_SELECTED_TREND_SIGNAL_SETTINGS, filteredSelected);
	},

	[RESET_STATE]: ({ commit }) =>
	{
		commit(RESET_STATE);
	},

	async [GET_TREND_SIGNAL_SETTINGS]({ commit, rootState })
	{
		commit("SET_IS_TREND_SETTINGS_LOADING", true);

		try
		{
			const selectedAssets = rootState.Trend.TrendMenu.TrendAssetSelector.selectedAssets;

			const trendSettingsData =
			await TrendSignalsService.GetTrendSignalSettingsByAssetsMonitoringElements(selectedAssets);

			if (!trendSettingsData || trendSettingsData.length === 0)
			{
				commit("CLEAR_AVAILABLE_SIGNALS");
				commit("SET_NO_DATA_AVAILABLE", true);
				return;
			}

			const commonSignals = trendSettingsData[0].commonSignals || [];
			const groupedDistinctSignals = [];

			trendSettingsData.forEach((assetSignals) =>
			{
				if (assetSignals.distinctSignals && assetSignals.distinctSignals.length > 0)
				{
					const assetName = assetSignals.assetName || assetSignals.name || assetSignals.asset;

					groupedDistinctSignals.push({
						assetName,
						signals: assetSignals.distinctSignals.map((signal) => ({
							...signal,
							asset: assetName
						}))
					});
				}
			});

			commit("SET_AVAILABLE_TREND_SIGNAL_SETTINGS", trendSettingsData);

			commit("SET_NO_DATA_AVAILABLE", false);
		}
		finally
		{
			commit("SET_IS_TREND_SETTINGS_LOADING", false);
		}
	},

	[GET_TREND_SIGNAL_SETTING_BY_ROUTE_ID]({ dispatch, state }, trendSignalRouteId)
	{
		if (trendSignalRouteId)
		{
			const foundedSignal = state.availableCommonSignals.find(s => s.trendSettingId === trendSignalRouteId);
		
			if (!!foundedSignal) dispatch(ON_TOGGLE_SIGNAL, foundedSignal);
		}
	},

	[ON_TOGGLE_SIGNAL]: ({
		state, commit, dispatch, rootState
	}, signal) =>
	{
		const selectedAssets = rootState.Trend.TrendMenu.TrendAssetSelector.selectedAssets || [];

		const signalsToToggle = [];

		selectedAssets.forEach(asset =>
		{
			const assetSignals = state.assetsTrendSettings.find(a => a.monitoringElementId === asset.id);
			if (!assetSignals)
			{
				return;
			}

			const commonMatch = (assetSignals.commonSignals || []).filter(s => s.name === signal.name);
			const distinctMatch = (assetSignals.distinctSignals || []).filter(s => s.name === signal.name);

			commonMatch.forEach(s => signalsToToggle.push({
				...s, assetName: asset.name, assetId:   asset.id || asset.assetName
			}));
			distinctMatch.forEach(s => signalsToToggle.push({
				...s, assetName: asset.name, assetId:   asset.id || asset.assetName
			}));
		});

		const updatedSignals = [ ...(state.selectedTrendSignalsSettings || []) ];

		signalsToToggle.forEach(s =>
		{
			const index = updatedSignals.
				findIndex(sel => sel.name === s.name && (sel.assetName || sel.asset) === (s.assetName || s.asset));
			if (index > -1)
			{
				updatedSignals.splice(index, 1);
			}
			else
			{
				updatedSignals.push(s);
			}
		});

		commit(SET_SELECTED_TREND_SIGNAL_SETTINGS, updatedSignals);
		dispatch(ON_CUSTOM_DOMAIN_COMPARISON);
	},

	[ON_CUSTOM_DOMAIN_COMPARISON]: ({ dispatch, rootState }) =>
	{
		dispatch(`${TREND_PATH}/${RESET_STATE}`, null, { root: true });

		const isCustomDomainComparisonChecked =
			rootState.Trend.TrendMenu.AdvancedSettingsDrawer.menu.isCustomDomainComparisonChecked;

		if (isCustomDomainComparisonChecked)
		{
			dispatch(
				`${ADVANCED_SETTINGS_DRAWER_PATH}/${TOGGLE_CUSTOM_DOMAIN_COMPARISON}`,
				false,
				{ root: true }
			);
		}
	},

	[TOGGLE_COMMON_GROUP_EXPANDED]: ({ commit, state }) =>
	{
		commit(TOGGLE_COMMON_GROUP_EXPANDED, !state.CommonGroupExpanded);
	},

	[TOGGLE_DISTINCT_GROUP_EXPANDED]: ({ commit, state }) =>
	{
		commit(TOGGLE_DISTINCT_GROUP_EXPANDED, !state.DistinctGroupExpanded);
	},

	[ON_TOGGLE_DISTINCT_ASSET_GROUP]: ({ commit }, assetName) =>
	{
		commit(ON_TOGGLE_DISTINCT_ASSET_GROUP, assetName);
	},

	[SET_DISTINCT_ASSET_GROUP]: ({ commit }, assetName) =>
	{
		commit(SET_DISTINCT_ASSET_GROUP, assetName);
	},

	[SHOW_GLOBAL_SIGNAL_NAME_DIALOG]: ({ commit }) =>
	{
		commit("SET_SHOW_SIGNAL_NAME_DIALOG", true);
	},

	[CLOSE_GLOBAL_SIGNAL_NAME_DIALOG]: ({ commit }) =>
	{
		commit("SET_SHOW_SIGNAL_NAME_DIALOG", false);
	},
	[SET_FILTER_TEXT]: ({ commit }, text) =>
	{
		commit(SET_FILTER_TEXT, text);
	},

	[LOAD_TREND_SIGNALS]: async({ dispatch, state }) =>
	{
		try
		{
			await dispatch(GET_TREND_SIGNAL_SETTINGS);

			if (state.noDataAvailable)
			{
				const message = i18n.t("ValidationMessages.NoGlobalValueSignalAvailable");
				dispatch(SHOW_TOAST_MESSAGE, { message, type: ToastMessageType.INFO }, { root: true });
			}

			await dispatch(SET_SELECTED_TREND_SIGNAL_SETTINGS);
		}
		catch (error)
		{
			const message = i18n.t("ErrorMessages.TrendSignalsRequestError");
			dispatch(SHOW_TOAST_MESSAGE, { message, type: ToastMessageType.ERROR }, { root: true });
		}
	},

	[SHOW_TOAST_MESSAGE]: ({ commit }, { message, type }) =>
	{
		commit("SET_TOAST_MESSAGE", message, { root: true });
		commit("SET_TOAST_TYPE", type, { root: true });
		commit("SET_SHOW_TOAST", true, { root: true });
	},

	[SET_MENU_OPENED]: ({ commit }, isOpen) =>
	{
		commit(SET_MENU_OPENED, isOpen);
	},
	[DESELECT_ALL_SIGNALS]: ({ commit }) =>
	{
		commit(CLEAR_SELECTED_TREND_SIGNALS);
	},
};

export default { actions };